module.exports = __webpack_public_path__ + "img/Graph_view_white.eea7cb9f.svg";